<section class="vo-card" aria-labelledby="step25-title">
  <header class="vo-card__head">
    <h2 class="vo-card__title" id="step25-title">Ihre Einzugsadresse</h2>
    <p class="vo-card__sub">Wohin ziehen Sie?</p>
  </header>

  <form class="vo-grid" [formGroup]="draftInquiryForm" novalidate>
    <div class="vo-field vo-field--full">
      <label class="vo-label" for="to_address">Einzugsadresse</label>
      <div class="vo-input-icon">
        <app-icon name="map-pin" class="vo-input-icon__icon"/>
        <input #toAddressInput id="to_address" type="text" class="vo-input" formControlName="address"
               placeholder="Strasse &amp; Hausnummer — Adresse suchen" autocomplete="off"
               [class.is-invalid]="hasError('address')">
        <app-google-places-autocomplete
          [forInput]="toAddressInput"
          [countries]="[draftInquiryForm.controls.country.value.toLowerCase()]"
          (placeSelected)="onAddressPlaceSelected($event)"/>
      </div>

      <div class="vo-address__row vo-address__row--country">
        <div class="vo-address__cell">
          <input #toZipInput id="to_zip" type="text" class="vo-input" formControlName="zip"
                 placeholder="PLZ" aria-label="PLZ" autocomplete="off" [class.is-invalid]="hasError('zip')">
          <app-google-places-autocomplete
            [forInput]="toZipInput"
            [countries]="[draftInquiryForm.controls.country.value.toLowerCase()]"
            [types]="['postal_code']"
            [minQueryLength]="2"
            (placeSelected)="onZipPlaceSelected($event)"/>
        </div>
        <div class="vo-address__cell">
          <input #toCityInput id="to_city" type="text" class="vo-input" formControlName="city"
                 placeholder="Ort" aria-label="Ort" autocomplete="off" [class.is-invalid]="hasError('city')">
          <app-google-places-autocomplete
            [forInput]="toCityInput"
            [countries]="[draftInquiryForm.controls.country.value.toLowerCase()]"
            [types]="['locality']"
            [minQueryLength]="2"
            (placeSelected)="onCityPlaceSelected($event)"/>
        </div>
        <div class="vo-address__cell vo-address__country">
          <select id="to_country" class="vo-select" formControlName="country" aria-label="Land">
            <option *ngFor="let option of countryOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>

      <p class="vo-error" *ngIf="hasError('address') || hasError('zip') || hasError('city')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte Strasse und Hausnummer, PLZ und Ort angeben
      </p>
    </div>

    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step25-object-type">Art des Objekts</span>
      <div class="vo-chips" role="group" aria-labelledby="step25-object-type">
        <button *ngFor="let option of objectTypeOptions" type="button" class="vo-chip"
                [class.is-selected]="isObjectTypeActive(option.value)"
                [class.is-invalid]="hasError('object_type')"
                [attr.aria-pressed]="isObjectTypeActive(option.value)"
                (click)="selectObjectType(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
      <p class="vo-error" *ngIf="hasError('object_type')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="to_floor">Etage</label>
      <select id="to_floor" class="vo-select" formControlName="floor" [class.is-invalid]="hasError('floor')">
        <option value="" disabled>Bitte wählen</option>
        <option *ngFor="let option of floorOptions" [value]="option">{{ option | inquiryFloor }}</option>
      </select>
      <p class="vo-error" *ngIf="hasError('floor')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <span class="vo-label" id="step25-lift">Lift vorhanden?</span>
      <div class="vo-seg" role="group" aria-labelledby="step25-lift">
        <button type="button" class="vo-seg__opt"
                [class.is-selected]="isHasLiftOptionSelected(true)"
                [class.is-invalid]="hasError('has_lift')"
                [attr.aria-pressed]="isHasLiftOptionSelected(true)"
                (click)="selectHasLift(true)">
          <app-icon name="arrow-up-down" [size]="16"/>
          Mit Lift
        </button>
        <button type="button" class="vo-seg__opt"
                [class.is-selected]="isHasLiftOptionSelected(false)"
                [class.is-invalid]="hasError('has_lift')"
                [attr.aria-pressed]="isHasLiftOptionSelected(false)"
                (click)="selectHasLift(false)">
          <app-icon name="ban" [size]="16"/>
          Ohne Lift
        </button>
      </div>
      <p class="vo-error" *ngIf="hasError('has_lift')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>
  </form>
</section>

<app-inquiry-step-nav (back)="goBack()" (next)="onSubmit()"/>
